import React, { useMemo, useState } from "react";
import { User } from "react-feather";
import InfoList from "../../InfoList";
import Grid from "../../Grid";
import { FORMS, MODULES } from "../../../const";
import { approveChargeReview } from "../../../api/finance/transporter-invoice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Button from "../../input/Button";
import {
  formatFromJsonDate,
  formatToDateOnlyFromJsonDate,
} from "../../../dateConfig";

const TransporterChargesReview = ({
  chargeReview,
  headerCharge,
  onApprovalSuccess,
}) => {
  console.log("header charge", headerCharge);
  console.log("charge review", chargeReview);
  const [loading, setLoading] = useState(false);

  const user = useSelector((state) => state.user);

  const jobSummary = useMemo(
    () => [
      { title: "Job Number", value: headerCharge?.tthReference || "N/A" },
      {
        title: "Transporter Name",
        value: headerCharge?.tthTransporterName || "N/A",
      },
      {
        title: "Status",
        value: headerCharge?.tthStatus === 2 ? "Approved" : "Pending",
      },
      {
        title: "Approved By",
        value: headerCharge?.tthApprovedBy || "N/A",
      },
      {
        title: "Approved Date",
        value: headerCharge?.tthApprovedDate
          ? formatToDateOnlyFromJsonDate(headerCharge.tthApprovedDate)
          : "N/A",
      },
    ],
    [headerCharge],
  );

  const gridData = useMemo(() => chargeReview || [], [chargeReview]);

  const completeCharges = useMemo(() => {
    if (!chargeReview) return [];

    return chargeReview.filter(
      (charge) =>
        charge.pickedByTransporter !== null &&
        charge.pickedByTransporter !== undefined &&
        charge.pickedByRateMaster !== null &&
        charge.pickedByRateMaster !== undefined,
    );
  }, [chargeReview]);

  const incompleteCharges = useMemo(() => {
    if (!chargeReview) return [];

    return chargeReview.filter(
      (charge) =>
        charge.pickedByTransporter === null ||
        charge.pickedByTransporter === undefined ||
        charge.pickedByRateMaster === null ||
        charge.pickedByRateMaster === undefined,
    );
  }, [chargeReview]);

  const hasCompleteCharges = completeCharges.length > 0;

  const getConfig = () => [
    {
      headerName: "Charge",
      field: "chargeName",
      editable: false,
      flex: 1,
    },
    {
      headerName: "Pick by Transporter",
      field: "pickedByTransporter",
      editable: false,
      valueFormatter: (params) => {
        const value = params.value;
        if (value === null || value === undefined) return "N/A";
        const n = Number(value);
        return isNaN(n) ? "N/A" : n.toFixed(2);
      },
    },
    {
      headerName: "Pick by Rate Master",
      field: "pickedByRateMaster",
      editable: false,
      valueFormatter: (params) => {
        const value = params.value;
        if (value === null || value === undefined) return "N/A";
        const n = Number(value);
        return isNaN(n) ? "N/A" : n.toFixed(2);
      },
    },
    {
      headerName: "Difference",
      field: "difference",
      editable: false,
      valueFormatter: (params) => {
        const value = params.value;
        if (value === null || value === undefined) return "N/A";
        const n = Number(value);
        return isNaN(n) ? "N/A" : n.toFixed(2);
      },
    },
  ];

  const handleApprove = async () => {
    if (!headerCharge?.tthId) {
      toast.error("Header ID not found", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    }

    if (!chargeReview || chargeReview.length === 0) {
      toast.error("No charges to approve", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    }

    if (headerCharge?.tthStatus === 2) {
      toast.warning("Charges are already approved", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    }
    if (!hasCompleteCharges) {
      toast.error(
        "No complete charges found. At least one charge must have both transporter and rate master values.",
        {
          autoClose: 5000,
          containerId: "Modal",
        },
      );
      return;
    }

    const chargeDetails = completeCharges.map((charge) => ({
      chargeId: charge.chargeId,
      rateMasterCharge: charge.pickedByRateMaster,
    }));

    const requestPayload = {
      jobId: headerCharge.tthJob,
      headerId: headerCharge.tthId,
      approvedBy: user.username,
      chargeDetails: chargeDetails,
    };

    console.log("Approval Request Payload:", requestPayload);

    try {
      setLoading(true);

      const response = await approveChargeReview(requestPayload);

      const successMessage =
        incompleteCharges.length > 0
          ? `${completeCharges.length} charge(s) approved successfully. ${incompleteCharges.length} incomplete charge(s) were skipped.`
          : `${completeCharges.length} charge(s) approved successfully!`;

      toast.success(successMessage, {
        autoClose: 5000,
        containerId: "Modal",
      });

      if (onApprovalSuccess) {
        onApprovalSuccess();
      }
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to approve charges. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const isApproveDisabled =
    loading || headerCharge?.tthStatus === 2 || !hasCompleteCharges;

  return (
    <div
      style={{
        width: "100%",
        padding: "0",
        boxSizing: "border-box",
      }}
    >
      <InfoList title="Job Details" content={jobSummary} Icon={User} />

      <div className="ui segment">
        <h4 className="ui header">Review Charges</h4>

        <Grid
          searchable={false}
          module={MODULES.Finance}
          heading="Charges Review"
          stopEditingWhenCellsLoseFocus={true}
          content={gridData}
          fullRowEdit={false}
          config={getConfig()}
          gridOptions={{
            getRowStyle: (params) => {
              const diffFlag = params.data?.diffFlag;
              if (diffFlag === 1) return { backgroundColor: "#FF6666" };
              if (diffFlag === 2) return { backgroundColor: "#FFFF66" };

              return null;
            },
          }}
        />

        <div className="ui divider" />

        <div
          style={{
            display: "flex",
            gap: 16,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <span
              style={{
                width: 14,
                height: 14,
                background: "#FF6666",
                display: "inline-block",
              }}
            />
            <span>Transporter charges are greater</span>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <span
              style={{
                width: 14,
                height: 14,
                background: "#FFFF66",
                display: "inline-block",
              }}
            />
            <span>Rate master charges are greater</span>
          </div>
        </div>
      </div>

      <div className="ui divider" />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
        <Button
          form={FORMS.REVIEW.CHARGE.form}
          module={MODULES.Finance}
          authenticated={true}
          className={`ui button ${loading ? "loading" : ""} ${
            headerCharge?.tthStatus === 2 ? "disabled" : "primary"
          }`}
          onClick={handleApprove}
          disabled={loading || headerCharge?.tthStatus === 2}
          label={headerCharge?.tthStatus === 2 ? "Already Approved" : "Approve"}
        />
      </div>
    </div>
  );
};

export default TransporterChargesReview;
